import { render, staticRenderFns } from "./BnTarifaData.vue?vue&type=template&id=2fe0ace8&scoped=true&"
import script from "./BnTarifaData.vue?vue&type=script&lang=js&"
export * from "./BnTarifaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0ace8",
  null
  
)

export default component.exports